import { Component, OnInit, Input } from '@angular/core';
import { PropertyData } from '../../../../models';
import { isEmptyStr } from '../../../../utilities/utilities.function';
import { BaseAddOnComponent } from '../base-addon.component';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-couple',
  templateUrl: './couple.component.html',
  styleUrls: ['./couple.component.css']
})
export class CoupleComponent extends BaseAddOnComponent implements OnInit {

  @Input('input') input: PropertyData;

  public val1: string;
  public val2: string;

  constructor() { super(); }

  ngOnInit(): void {
    this.val1 = isEmptyStr(this.input.MainElementList[0].Value.split('|')[0]) ? '0' : this.input.MainElementList[0].Value.split('|')[0];
    this.val2 = isEmptyStr(this.input.MainElementList[0].Value.split('|')[1]) ? '0' : this.input.MainElementList[0].Value.split('|')[1];
  }

  setCouple(val1: string, val2: string): void {
    this.input.MainElementList[0].Value = `${val1}|${val2}`;
  }
}
